import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TCardProductDesktop, TCardProductMobile } from '../models';

// TODO: Отрефачить компонент:
// - Название с большой буквы
// - headingView стоит доставать из пропсов
export const renderBottomBlock: FC<TCardProductDesktop | TCardProductMobile> = (
    props,
    headingView
) => {
    const {
        Grid,
        Text,
        bottomRightText,
        bottomSubtitle,
        bottomTitle,
        dataTestId = 'card-product-bottom-block',
        styles,
        textTheme,
    } = props;

    const primaryText = (
        <Text
            className={cn(styles.external, styles.bottomPrimaryText)}
            dataTestId={`${dataTestId}-primary-text`}
            styler={{
                marginTop: 0,
                marginRight: bottomRightText ? 8 : 0,
                marginLeft: 0,
                marginBottom: 0,
            }}
            theme={textTheme}
            view={headingView}
        >
            {bottomTitle}
        </Text>
    );

    const secondaryText = (
        <Text
            className={cn(styles.external, {
                [styles.bottomTextMarginBottom]: bottomTitle || bottomRightText,
            })}
            dataTestId={`${dataTestId}-secondary-text`}
            styler={{ marginTop: 0, marginBottom: 0 }}
            theme={textTheme}
            view="primary-medium"
        >
            {bottomSubtitle}
        </Text>
    );

    return (
        <>
            {bottomSubtitle && secondaryText}
            {!bottomRightText && bottomTitle && primaryText}
            {bottomRightText && (
                <Grid alignment colAutoWidth collapse justify="start">
                    {bottomTitle && primaryText}
                    <Text
                        dataTestId={`${dataTestId}-bottom-right-text`}
                        styler={{ marginTop: 0, marginBottom: 0 }}
                        theme={textTheme}
                        view="component-secondary"
                    >
                        {bottomRightText}
                    </Text>
                </Grid>
            )}
        </>
    );
};
